import gql from 'graphql-tag';
import HelperGraphql from "utils/helper-graphql";

const fields = {
	'guid': 'String!',
	'active': 'String!',
	'status': 'String',
	'cancel_reason': 'String',
	'lunch_option_guids': '[String]',
	'license_plate': 'String',
}

export default gql(`
	mutation employee_booking( ${ HelperGraphql.createFields( fields ) } ) {
	    employee_booking( ${ HelperGraphql.createVariables( fields ) } ) {
	        guid
	        active
	    }
	}
`);

